import './ListerControls.scss';

import classnames from 'classnames';
import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { useIsBelowSmallOnly } from '../../hooks/mediaQueries';
import { useEventListener } from '../../hooks/useEventListener';
import Refine from '../ListerControls/Refine';
import SortBy from '../ListerControls/SortBy/SortBy';
import SortByDiscount from '../ListerHeader/SortByDiscount';

const ListerControls = () => {
	const ref = useRef(null);
	const { CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	const { EnableGoodGrowthPlpFilters } = useSelector(
		(state) => state.featureSwitches
	);

	const isBelowSmallOnly = useIsBelowSmallOnly();

	const [sticky, setSticky] = useState(false);
	const [holderHasClass, setHolderHasClass] = useState(false);

	const handleScroll = () => {
		const topPos = ref.current?.getBoundingClientRect().top;

		const isAtTop = topPos <= 16;

		setSticky(isAtTop);

		if (isAtTop && !holderHasClass) {
			setHolderHasClass(true);
			// eslint-disable-next-line no-unused-expressions
			document.querySelector('#holder')?.classList.add('overflow-visible');
		}
	};

	useEventListener('scroll', handleScroll);

	return (
		<section
			ref={ref}
			className={classnames('lister__controls', {
				'px-4 pt-2 shadow-none': sticky && !CustomCategoriesEnabled,
				'p-0': isBelowSmallOnly && !CustomCategoriesEnabled,				
			})}
			data-tag-section="lister controls">
			<div
				className={classnames('lister__controls-header', {
					'p-0': isBelowSmallOnly && !CustomCategoriesEnabled,
					'overflow-hidden': sticky,
					rounded: sticky && !CustomCategoriesEnabled,
					'p-2 bg-white rounded-b-md lister__controls-mobile-shadow':
						sticky && CustomCategoriesEnabled,
				})}>
				<div className="w-full pr-px">
					<SortBy
						sticky={sticky}
						customCatsEnabled={CustomCategoriesEnabled}
						mobile
					/>
				</div>

				<Refine sticky={sticky} customCatsEnabled={CustomCategoriesEnabled} />
			</div>
			{!sticky && (
				<div className="pt-2">
					<SortByDiscount />
				</div>
			)}
		</section>
	);
};

export default ListerControls;
